// src/components/ui/Button.js
import React from 'react';
import { ClipLoader } from 'react-spinners';

const variants = {
  primary: 'bg-primary text-white hover:bg-brand-700 shadow-md',
  secondary: 'bg-secondary text-white hover:bg-indigo-700 shadow-sm',
  outline: 'bg-transparent border-2 border-gray-200 text-gray-600 hover:border-brand-600 hover:text-brand-600',
  ghost: 'bg-transparent text-gray-500 hover:bg-gray-100',
  destructive: 'bg-destructive text-white hover:bg-red-700',
  accent: 'bg-accent text-black hover:bg-amber-600 font-bold',
};

const sizes = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
  xl: 'px-8 py-4 text-lg font-bold',
};

export function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  loading = false, 
  disabled = false,
  className = '',
  icon: Icon,
  ...props 
}) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:pointer-events-none disabled:active:scale-100';
  
  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <ClipLoader size={18} color="currentColor" className="mr-2" />
      ) : Icon ? (
        <Icon className="w-4 h-4 mr-2" />
      ) : null}
      {children}
    </button>
  );
}
